module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/340f5a3d6ae326f22b9707104adf6bb9.png";